(function () {
    'use strict';
    angular.module('Services').factory('RPRunsTable', RPRunsTable);
    RPRunsTable.$inject = [
        'TableLiteFactory',
        'FleetService',
        '$uibModal',
        '$filter'
    ];

    function RPRunsTable(
        TableLiteFactory,
        FleetService,
        $uibModal,
        $filter
    ) {
        return function () {
            const tableData = {
                tableName: 'RPRunsTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [
                    {
                        label: 'DATE & TIME',
                        viewName: 'dateTime',
                        filterName: 'createdDate',
                        filter: {
                            type: 'datePicker',
                            class: 'filter-date',
                            useArray: true,
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Driver',
                        viewName: 'driver',
                        filterName: 'driverId',
                        width: '150px',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Stops',
                        viewName: 'stops',
                        filterName: 'stops',
                    },
                    {
                        label: 'Status',
                        viewName: 'routePlanStatus',
                        filter: {
                            // todo: need to fix this one here
                        },
                        headerFn: function() {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Actions',
                        viewName: 'actions',
                        width: '200px'
                    }
                ],
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: FleetService.RoutePlanning.getAllRuns,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                },
                defaultFilters: {}
            });

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                angular.forEach(data.content, (item) => {
                    item.dateTime = $filter('bbaDate')(item.createdDate, true);
                    item.driver = {
                        type: 'multiLine',
                        list: parseDriverAddress(item),
                        truncateLength: 100
                    };
                    item.stops = {
                        type: 'waypoints',
                        waypoints: item.stops.map(stop => {
                            return {
                                jobId: stop.jobId,
                                address: parseStopAddress(stop)
                            }
                        }),
                    };
                    item.routePlanStatus = item.routePlanStatus.toUpperCase();
                    item.actions = {
                        type: 'button',
                        buttons: [{
                            text: 'View Details',
                            icon: '',
                            class: 'btn-primary',
                            action: (data) => {
                                showRouteDetailsModal(data.id);
                            }
                        }]
                    };
                    tableData.data.push(item);
                });
            }

            function showRouteDetailsModal(id) {
                $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/route-planning/modal/route-planning-modal.html',
                    controller: 'RoutePlanningModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    appendTo: $('body'),
                    resolve: {
                        jobs: () => { return null; },
                        id: () => { return id; }
                    }
                });
            }

            function parseStopAddress(stop) {
                const { addressLine1, addressLine2, cityOrSuburb, postcode } = stop;
                return `${addressLine1} ${addressLine2 || ''} ${cityOrSuburb} ${postcode}`;
            }

            function parseDriverAddress(item) {
                const { driverAddress, driverFirstName, driverLastName } = item;
                return [
                    `${driverFirstName || ''} ${driverLastName || ''}`,
                    `${driverAddress.addressLine1} ${driverAddress.addressLine2} ${driverAddress.cityOrSuburb} ${driverAddress.postcode}`,
                    `${driverAddress.latitude}, ${driverAddress.longitude}`
                ];
            }

            this.tableData = tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/route-planning/RPRunsTable.js